<div class="tw-text-center sm:tw-text-left">
    <ng-container *ngIf="!isDGP">
        <p class="tw-w-full tw-text-[28px] md:tw-text-[40px] tw-text-[#0F3172] tw-font-bold">
            {{ "NEW_PRODUCTS.BUSINESS_FINANCING.TITLE" | translate }}
        </p>
        <p class="tw-py-1 tw-text-[#1A202C] tw-font-thin">
            {{ "NEW_PRODUCTS.BUSINESS_FINANCING.DESCRIPTION" | translate }}
        </p>
        <p class="tw-text-[#1A202C] tw-font-thin">
            {{ "NEW_PRODUCTS.BUSINESS_FINANCING.DESCRIPTION1" | translate }}
        </p>
    </ng-container>
    <ng-container *ngIf="isDGP">
        <p class="tw-w-full tw-text-[28px] md:tw-text-[40px] tw-text-[#0F3172] tw-font-bold">
            {{ "NEW_PRODUCTS.DGP.TITLE" | translate }}
        </p>
        <p class="tw-py-1 tw-text-[#1A202C] tw-font-thin">
            {{"NEW_PRODUCTS.DGP.DESCRIPTION" | translate}}
        </p>
        <p class="tw-text-[#1A202C] tw-font-thin">
            {{"NEW_PRODUCTS.DGP.DESCRIPTION1" | translate}}
        </p>
    </ng-container>
</div>